// TODO: creator tile component due to the new design
import { memo, useCallback } from "react";
import { Link } from "react-router-dom";
import { routes } from "@/common/utils/routes";
import { Image } from "components";
import { nFormatter } from "@/common/utils/parseNumber";
import { IUser } from "@/common/services/types";
import { clsx } from "clsx";
import { Button } from "components/buttons/Button";
import UsersIcon from "@/common/images/icons/users.svg?react";
import CheckIcon from "@/common/images/icons/check.svg?react";
import PlusIcon from "@/common/images/icons/plus.svg?react";
import FALLBACK from "@/common/images/user-empty.svg";
import { VerifiedIcon } from "components/UI/VerifiedIcon";
import "./CreatorTile.scss";
import { useUserSubscription } from "@/common/hooks/useUserSubscription";

interface ICreatorTile {
  user: IUser;
  onTileClick?: () => void;
}

export const CreatorTile: React.FC<ICreatorTile> = memo(({
  user,
  onTileClick
}) => {
  const { subscribed, subscribe, unsubscribe } = useUserSubscription(user.username);

  const onSubscribe = useCallback(() => subscribed ? unsubscribe() : subscribe(), [subscribed]);

  return (
    <div className="CreatorTile">
      <div className="CreatorTile-Cnt">
        <div className="CreatorTile-ImgWrap">
          <Link to={routes.user(user.username)} onClick={onTileClick} aria-label={`Link to ${user.name} profile`}>
            <Image src={user.profileImageUrl || user.poster} fallback={FALLBACK} alt={`Poster for ${user.name}`} />
          </Link>
        </div>
        <div className={clsx("CreatorTile-Follow", subscribed && "CreatorTile-Follow_isFollowed")}>
          <Button
            variant="primary"
            size="xs"
            onClick={onSubscribe}
            aria-label={`Follow ${user.name}`}
            round
          >
            {subscribed ? <CheckIcon /> : <PlusIcon />}
          </Button>
        </div>
      </div>
      <div className="CreatorTile-Labels">
        <Link className="CreatorTile-Link" to={routes.user(user.username)} onClick={onTileClick}>
          <span className="CreatorTile-LinkText">{user.name || user.username}</span>
          {user.verified && (
            <VerifiedIcon title={`Verified ${user.studio ? "studio" : "user"}`} isStudio={user.studio} />
          )}
        </Link>
        <div className="CreatorTile-Subscribes" title={`${nFormatter(user.followers)} Subscribers`}>
          <UsersIcon />
          <span>{nFormatter(user.followers)}</span>
        </div>
      </div>
    </div>
  );
});
